import { IAccountMeta } from 'src/explore/types/shoppe';

export const initializeSegment = ( meta: IAccountMeta ) => {
  if ( meta.identify_traits['email_identity_id']) {
    window.analytics.identify(
      meta.identify_traits['email_identity_id'],
      meta.identify_traits
    );

    if ( meta.identify_traits['Goldbely Visitor Tracking Code']) {
      window.analytics.alias(
        meta.identify_traits['email_identity_id'],
        meta.identify_traits['Goldbely Visitor Tracking Code']
      );
    };

    window.analytics.alias( meta.identify_traits['email_identity_id']);
  }
  // else user is not logged in, the identity is only visitor id
};
